<template>
  <div>
    <component
      :is="componentName || defaultComponent"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import { COMPONENTS_ROUTER_LIST } from '@/noSAAS/components'
import { HANDLE_ROUTER_LIST } from '@/noSAAS/handle'
import noSAAS from '@/mixin/noSAAS'
import { getRouterStr } from '@/noSAAS/utils'
export default {
  name: 'SpComponent',
  mixins: [noSAAS],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    //默认渲染
    defaultComponent: {
      type: String,
      default: ''
    },
    //定位模块；
    myName: {
      type: String,
      default: '_myName'
    },
    // 唯一标示，避免一个页面内多次引用同一个组件时冲突；
    myId: {
      type: String,
      default: '_mid_' + new Date().getTime()
    }
  },
  data () {
    const routerPath = getRouterStr(this.$route.fullPath)
    const SPCompanyId = process.env.VUE_APP_COMPANY_ID
    function getNoSAAS (model) {
      let val = null
      if (SPCompanyId && routerPath) val = model[SPCompanyId][routerPath][this.myName]
      return val
    }
    const handleFun = getNoSAAS(HANDLE_ROUTER_LIST)
    const componentName = getNoSAAS(COMPONENTS_ROUTER_LIST)
    return {
      handleFun,
      componentName,
      routerPath,
      SPCompanyId
    }
  },
  watch: {
    $attrs: {
      deep: true,
      handler: function (val, oldVal) {
        // console.log('$attrs-Change', { ...val })
      }
    }
  },
  mounted () {
    const { SPCompanyId, routerPath, myName } = this
    console.log('mounted-SPCompanyId', SPCompanyId)
  },
  methods: {
    callHandle () {
      const { SPCompanyId, routerPath, myName } = this
      console.log('callHandle-handleFun', HANDLE_ROUTER_LIST[SPCompanyId][routerPath][myName])
      this.handleFun.apply(this, [this, ...arguments])
    },
    getComponent () {
      // return componentsList[this.SPCompanyId][this.$route.fullPath]
    }
  }
}
</script>

<style lang="scss" scoped></style>
